module.exports = function(angular, app) {
  var serializer = require('../../deep-query-api/lib/serializer');
  var autoname = require('../../deep-query-api/lib/autoname');

  app.factory('deepQuerySerializer', function() {
    return {
      serialize: serializer.serialize,
      deserialize: serializer.deserialize,
      deserializeLegacy: serializer.deserializeLegacy,
      autoNameColumn: autoname.autoName,
      autoNameGenerator: autoname.autoNameGenerator,
      queryMetricNameFromIndex: autoname.queryMetricNameFromIndex
    }
  });
};
